"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ui = require("@probeton/ui");

var _CreateUserDialog = _interopRequireDefault(require("./CreateUserDialog"));

var _excluded = ["units", "assignedUnits", "editableUnits", "handleUnitChange", "handleUnitClick"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CreateRepDialog = function CreateRepDialog(_ref) {
  var units = _ref.units,
      assignedUnits = _ref.assignedUnits,
      editableUnits = _ref.editableUnits,
      handleUnitChange = _ref.handleUnitChange,
      handleUnitClick = _ref.handleUnitClick,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_CreateUserDialog["default"], props, units && /*#__PURE__*/_react["default"].createElement(_ui.RepresentativeAssignUnits, {
    units: units,
    assignedUnits: assignedUnits,
    editableUnits: editableUnits,
    isAdmin: false,
    handleUnitClick: handleUnitClick,
    handleUnitChange: handleUnitChange,
    info: props.labels.info
  }));
};

CreateRepDialog.propTypes = {};
CreateRepDialog.defaultProps = {};
var _default = CreateRepDialog;
exports["default"] = _default;